import React from 'react';

const Spinner: React.FC<{ className?: string }> = ({ className = 'h-10 w-10' }) => (
  <svg className={`animate-spin text-primary-600 ${className}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden>
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  </svg>
);

export const PageLoading: React.FC<{ label?: string }> = ({ label = 'Loading…' }) => (
  <div className="flex flex-col items-center justify-center py-20 gap-3" role="status" aria-live="polite">
    <Spinner />
    <p className="text-sm text-gray-500">{label}</p>
  </div>
);

const LoadingOverlay: React.FC = () => (
  <div className="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center z-50">
    <Spinner />
  </div>
);

export default LoadingOverlay;
